module.exports = __webpack_public_path__ + "static/media/graphql-optimized.5880939b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/05-why-gatsby/images/graphql-optimized.jpg
// module id = 955
// module chunks = 0